import { Component, OnInit, Injector,ErrorHandler } from '@angular/core';
import { UntypedFormGroup, Validators, UntypedFormBuilder, FormArray } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../../../shared/common.service';
import { AlertService } from '../../../common/alert.service';
import { MatDialog } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { Global } from 'src/app/Global';
import { AuditTrailComponent } from 'src/app/out-of-application/audit-trail/audit-trail.component';
import { AppTokenHandler, HTTPStatus } from 'src/app/common/app-token-handler';
import { AppErrorHandler } from 'src/app/common/app-error-handler';
import { EmployeeRecoveryService } from '../../../shared/employee-recovery.service';
import { WaveOFFComponent } from '../wave-off/wave-off.component';
import { TwoDigitDecimaNumberDirective } from 'src/app/two-digit-decima-number.directive';
import saveAs from 'file-saver';
import { DropdownModule } from 'primeng/dropdown';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatCardModule } from '@angular/material/card';
import { ReactiveFormsModule } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

// import { stringify } from '@angular/core/src/util';
// import { DISABLED } from '@angular/forms/src/model';

@Component({
  selector: 'app-create-recovery',
  templateUrl: './create-recovery.component.html',
  styleUrls: ['./create-recovery.component.css'],
  // standalone:true,
  // imports: [DropdownModule,MatDatepickerModule,MatCardModule
  //   ,ReactiveFormsModule,MatNativeDateModule,CommonModule,MatFormFieldModule,MatInputModule],
  // providers: [
  //   { provide: ErrorHandler, useClass: AppErrorHandler }]
})
export class CreateRecoveryComponent implements OnInit {
  RecoveryCreationForm: UntypedFormGroup;
  employeeList: any;
  filterList: any;
  private alertService: AlertService;
  IsSecondaryZoneVisible = false;
  RecoveryID: string;
  btnValue: string;
  IsSecondaryOwner: boolean;
  UserDetails: any;
  StatusRecord: string;
  NewRequestID: string;
  PenaltyTypeList: any;
  AssestTypeList: any;
  ReportedLocationList: any;
  EmpRecoveryGPN: string;
  NewRequest: string;
  InputValue: any;
  displayedColumns = ['RequestRecoveryNumber', 'IsFullWaiveOff', 'WaiveOffAmount', 'WaiverDate', 'Remarks', 'JVNumber', 'AttachmentName'];
  EmployeeWaiveOffDataSource: MatTableDataSource<any[]>;
  WaiveOffStatusID: boolean = false;
  StatusCheck: boolean = false;
  IsWaiveoffAmountCheckStatus: boolean = false;
  ISEditVisible: boolean;



  /***********************************End***************************************************/
  constructor(private _fb: UntypedFormBuilder, private _router: Router, private error: AppErrorHandler,
    private _activeRoute: ActivatedRoute, public _commonService: CommonService,
    injector: Injector, private _dialog: MatDialog,
    public _global: Global, private appToken: AppTokenHandler,
    private _EmployeeService: EmployeeRecoveryService,
    private status: HTTPStatus) { this.alertService = injector.get(AlertService); }

  ngOnInit() {
    /*****************************GetData By QueryString*************************/
    this.UserDetails = this.appToken.getLoginUserInfo();

    this.RecoveryID = this._activeRoute.snapshot.paramMap.get('ID');
    /**************************************End**********************************/

    this.RecoveryCreationForm = this._fb.group({
      RequestEntityId: [''],
      RequisitionDate: [new Date()],
      RecoveryID: [''],
      EmpRecoveryGPN: [],
      UserNameEmployeeRecovery: [],
      SecondaryZoneHeadName: [],
      SecondaryZoneHeadGPN: [],
      SecondaryZoneHeadEmail: [],
      SecondaryZoneHeadCUG: [],
      EmailAddress: ['', [Validators.required]],
      UserOfficeLocation: [''],
      UserEntity: [''],
      PenaltyTypeID: ['', [Validators.required]],
      PenaltyType: [],
      AssetTypeID: ['', [Validators.required]],
      AssetType: [],
      AssetMakeAndModel: ['', [Validators.required, Validators.maxLength(200)]],
      AssetSrAndMDN: ['', [Validators.required, Validators.maxLength(200)]],
      ReportedLocationID: ['', [Validators.required]],
      ReportedLocationName: [],
      ReportedDate: [new Date],
      PenaltyAmount: ['', [Validators.required, Validators.maxLength(10)]],
      UserEmailForm: [],
      UserOfficeLocationForm: [],
      UserEntityForm: [''],
      NetRecoveryAmountID: [''],
      AttachmentDTO: [],
      AttachmentID: [],
      AttachmentName: [],
      EmpFirmID: [],
      EMPOffLocationID: [],
      StatusRecord: [],
      lblEmployeeName: [],
      tempblobFileId:[]
    });

    this.IsSecondaryOwner = false;
    this.BindAssetTypeList();
    this.BindPenaltyTypeList();
    this.BindReportedLocationList();


    if (this.RecoveryID != null) {

      this.btnValue = 'Update';
      this.StatusRecord = 'Submitted';
      this.NewRequest = 'View Record';
      this._global.IsAuditVisible = true;
      this.RecoveryCreationForm.controls.RequestEntityId.setValue(this.RecoveryID);
      this.GetEmployeeRecoveryDataByID(this.RecoveryID);
      this._global.auditTrailId = this.RecoveryID;
      this._global.auditTrailClass = 'EmployeeRecovery';
      this._global.RecoveryID = this.RecoveryID;

    } else {
      this.btnValue = 'Submit';
      this.StatusRecord = 'New';
      this.NewRequest = 'New Request';
      this.NewRequestID = 'TBG';
      this._global.IsAuditVisible = false;
      this._global.auditTrailId = this._global.auditTrailClass = '';
    }
  }
  /****************************Section: Methods****************************/
  BindPenaltyTypeList() {
    this._commonService.BindDropDown('Penalty').subscribe(result => {
      this.PenaltyTypeList = result;
    });
  }
  BindAssetTypeList() {
    this._commonService.BindDropDown('Assest').subscribe(result => {
      this.AssestTypeList = result;
    });
  }
  BindReportedLocationList() {
    this._commonService.BindDropDown('Location').subscribe(result => {
      this.ReportedLocationList = result;
    });
  }

  SearchActiveEmployee = (event) => {
    debugger
    this.status.setHttpStatus(true);
    this._commonService.Autocomplete('FillCommonData/GetActiveEmployeeRecovery', event.query).subscribe(result => {
      this.employeeList = this.filterDataList(event.query, result);
    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    }, () => {
      this.status.setHttpStatus(false);
    });
  }

  filterDataList(query, dataList: any): any[] {
    const filtered: any[] = [];
    for (let i = 0; i < dataList.length; i++) {
      this.filterList = dataList[i];
      filtered.push(this.filterList);
    }
    return filtered;
  }
  // orgValueChange(keyName: String) {
  //   if (keyName === 'ReportedDate') {
  //     if (this.RecoveryCreationForm.controls.AssetInstallationDate.value !== '' &&
  //       this.RecoveryCreationForm.controls.AssetInstallationDate.value !== null) {
  //       if (this.RecoveryCreationForm.controls.AssetPurchaseDate.value > this.RecoveryCreationForm.controls.AssetInstallationDate.value) {
  //         this.RecoveryCreationForm.controls.AssetPurchaseDate.reset();
  //         this.RecoveryCreationForm.controls.AssetInstallationDate.reset();
  //         this.alertService.notify('warn', 'warn!', 'Asset purchase date can not be smaller than installation date.');
  //       }
  //     }
  //   }
  // }

  clearAutoComplete(controlName) {
    if (controlName === 'UserNameEmployeeRecovery') {
      this.RecoveryCreationForm.controls.SecondaryZoneHeadName.reset();
      this.RecoveryCreationForm.controls.SecondaryZoneHeadGPN.reset();
      this.RecoveryCreationForm.controls.SecondaryZoneHeadCUG.reset();
      this.RecoveryCreationForm.controls.SecondaryZoneHeadEmail.reset();
    }
    if (controlName === 'LocationHead') {
      this.RecoveryCreationForm.controls.LocationHeadGPN.reset();
      this.RecoveryCreationForm.controls.CUG.reset();
      this.RecoveryCreationForm.controls.Email.reset();
      this.RecoveryCreationForm.controls.MobileNumber.reset();
    }
  }

  SetEmployeeDetails(event) {
    if (event.EmployeeGPN === this.RecoveryCreationForm.controls.SecondaryZoneHeadGPN.value) {
      alert('Primary location head can not be same as Secondary.');
      this.RecoveryCreationForm.controls.LocationHead.reset();
    } else {
      this.RecoveryCreationForm.patchValue({
        LocationHeadGPN: event.EmployeeGPN,
        CUG: event.EmpCUG,
        Email: event.EmpEmail,
        MobileNumber: event.EmpMobile,
        LocationHeadName: event.EmpName
      });
    }
  }

  SetSecondaryEmployeeDetails(event) {
    this.RecoveryCreationForm.patchValue({
      SecondaryZoneHeadName: event.EmpName,
      SecondaryZoneHeadGPN: event.EmployeeGPN,
      SecondaryZoneHeadCUG: event.EmpLocation,
      SecondaryZoneHeadEmail: event.EmpEmail,
      EmpRecoveryGPN: event.EmployeeGPN
    });

    this._global.SecondaryHeadBtnVisible = true;
    this.RecoveryCreationForm.controls.EmailAddress.setValue(event.EmpEmail);
    this.RecoveryCreationForm.controls.UserOfficeLocation.setValue(event.EmpLocation);
    this.RecoveryCreationForm.controls.UserEntity.setValue(event.EmpFirm);
    this.RecoveryCreationForm.controls.EmpFirmID.setValue(event.EmpFirmID);
    this.RecoveryCreationForm.controls.EMPOffLocationID.setValue(event.EMPOffLocationID);
  }

  ValidationMessage() {
    if (this.RecoveryCreationForm.controls.PenaltyAmount.value !== '' && this.RecoveryCreationForm.controls.PenaltyAmount.value != null) {
      if (this.RecoveryCreationForm.controls.PenaltyAmount.value <= 0) {
        this.RecoveryCreationForm.controls.PenaltyAmount.reset();
        this.alertService.notify('warn', 'warn!', 'penalty amount can not be zero.');
      }
    }
  }

  ReportedLocationChange($event) {
    if (this.ReportedLocationList && $event.value) {
      var x = this.ReportedLocationList.find((x: any) => x.value == $event.value);
      this.RecoveryCreationForm.controls.ReportedLocationName.setValue(x.label);
    }
  }
  PenaltyTypeChange($event) {
    if (this.PenaltyTypeList && $event.value) {
      var x = this.PenaltyTypeList.find((x: any) => x.value == $event.value);
      this.RecoveryCreationForm.controls.PenaltyType.setValue(x.label);
    }
  }

  AssetTypeChange($event) {

    if (this.AssestTypeList && $event.value) {
      var x = this.AssestTypeList.find((x: any) => x.value == $event.value);
      this.RecoveryCreationForm.controls.AssetType.setValue(x.label);
    }
  }



  SaveEmployeeRecovery() {

    if (!this.RecoveryCreationForm.valid) {
      alert('Please fill mandatory fields.');
      this.showErrorsOnInvalidForm();
      return false;
    }
    this.status.setHttpStatus(true);

    this._EmployeeService.AddEmployeeMaster(this.RecoveryCreationForm.value).subscribe(data => {
      if (data.RequestIsSuccess) {
        debugger
        if (data.RequestEntityId !== null) {
          alert(data.RequestMessage);
          //Commented below and added if else condition by Shreya for CR_2408_0166
          //this.alertService.notify('success', 'Success!', data.RequestMessage);
          // this._router.navigate(['admin/view-recovery']);
          if (data.RequestMessage === 'Record updated successfully')
            window.location.reload();
          else
            this._router.navigate(['admin/create-recovery', data.RequestEntityId]);
        }
      } else {
        alert(data.RequestMessage);
        // this._router.navigate(['admin/create-recovery', data.RequestEntityId]);
        //this.alertService.notify('warn', 'warn!', data.RequestMessage);
      }
    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    },
      () => { this.status.setHttpStatus(false); });
  }

  GetEmployeeRecoveryDataByID(RecoveryID: string) {
    debugger
    this.status.setHttpStatus(true);
    this._EmployeeService.GetEmployeeRecoveryDataByID(RecoveryID).subscribe(data => {
      this.RecoveryCreationForm.patchValue(data);
      this.RecoveryCreationForm.controls.RecoveryID.setValue(data.RequestEntityId);
      this.RecoveryCreationForm.controls.UserOfficeLocation.setValue(String(data.UserOfficeLocation))
      this.RecoveryCreationForm.controls.UserEntity.setValue(String(data.UserEntity))
      this.RecoveryCreationForm.controls.PenaltyTypeID.setValue(String(data.PenaltyTypeID));
      this.RecoveryCreationForm.controls.AssetTypeID.setValue(String(data.AssetTypeID));
      this.RecoveryCreationForm.controls.ReportedLocationID.setValue(String(data.ReportedLocationID));

      this.RecoveryCreationForm.controls.lblEmployeeName.setValue(String(data.EmpName));
      this.RecoveryCreationForm.controls.EmailAddress.setValue(String(data.EmailAddress));
      this.RecoveryCreationForm.controls.UserNameEmployeeRecovery.setValue(String(data.EmpName));
      this.RecoveryCreationForm.controls.StatusRecord.setValue(String(data.Status));
      this.NewRequestID = String(data.RecoveryRequestID);
      this.EmpRecoveryGPN = String(data.EmpRecoveryGPN);
      this.StatusRecord = String(data.Status);
      this.RecoveryCreationForm.controls.NetRecoveryAmountID.setValue(data.NetRecoveryAmount);
      this.WaiveOffStatusID = data.WaiveOffStatusID;
      this.ISEditVisible = data.ISEditVisible;
      this.StatusCheck = this.ISEditVisible == true ? true : false;
      this.IsWaiveoffAmountCheckStatus = data.NetRecoveryAmount == 0 ? true : false;
      if (data.WaveOffSecondaryHeadForm != null && data.WaveOffSecondaryHeadForm.length > 0) {
        this.EmployeeWaiveOffDataSource = new MatTableDataSource(data.WaveOffSecondaryHeadForm);
      }
    }, (error) => {
      this.status.setHttpStatus(false);
      this.error.handleError(error);
    }, () => {
      this.clearAutoComplete('UserNameEmployeeRecovery');
      this.status.setHttpStatus(false);
    });
  }

  /**********************************Method Section End****************************************/

  openAuditTrailDialog() {
    this._dialog.open(AuditTrailComponent,
      {
        width: '1000px',
        disableClose: true
      });
  }


  ShowAttachment(row: any) {
    this.RecoveryCreationForm.controls.AttachmentID.setValue(row.AttachmentID);
    this._EmployeeService.GetAttachment(this.RecoveryCreationForm.value).subscribe(x => {
      const blob = new Blob([x], { type: 'application/octet-stream' });
      saveAs(blob, row.AttachmentName);
    });
  }

  openWaveOFFDialog() {
    this._dialog.open(WaveOFFComponent,
      {
        width: '1250px',
        height: '600px',
        disableClose: true
      });
  }
  /****************************Error and Validation Section***********************************/
  GetFormControls(controlName) {
    return this.RecoveryCreationForm.controls[controlName];
  }

  showErrorsOnInvalidForm() {

    Object.keys(this.RecoveryCreationForm.controls).forEach(field => {
      const control = this.RecoveryCreationForm.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }


  blockSpecialChar(e) {
    var k = e.keyCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || (k >= 48 && k <= 57));
  }

  /**********************************Error Section End***************************************/
}
